<template>
  <div>
    <div v-if="step == 'form'">

      <div class="form-row">
        <div class="col-md-4">
          <div class="form-group" v-bind:class="{ 'has-error': errors.name }">
            <input placeholder="Ваше имя" v-on:keypress="isLetter($event)" type="text" class="form-control" v-model="contact.name">
            <p class="help-block" v-if="errors.name">
              {{ errors.name.join(', ') }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group" v-bind:class="{ 'has-error': errors.contact }">
            <input v-mask="'+7(###)###-##-##'" placeholder="+7(xxx)xxx-xx-xx" type="text" class="form-control" v-model="contact.contact">
            <p class="help-block" v-if="errors.contact">
              {{ errors.contact.join(', ') }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <button type="button" class="btn btn-primary" v-on:click="sendForm">Получить консультацию</button>
        </div>
      </div>
      <div class="form-bottom">
        <p class="form-bottom-text">Отправляя форму, вы соглашаетесь с <a href="/legal/">условиями</a> политики конфиденциальности</p>
      </div>
    </div>

    <div v-if="step == 'complete'">
      <p class="text-success">
        Ваше сообщение успешно отправлено! Мы свяжемся с Вами в ближайшее время.
      </p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueMask from 'v-mask'

import FormMixin from '../vue_mixins/FormMixin.vue'

Vue.use(VueMask)


export default {
  name: 'CallmeFormInline',
  mixins: [FormMixin],
  data() {
    return {
      contact: {},
      errors: {},
      step: 'form'
    }
  },
  mounted() {
    axios.get("/contacts/api/callme/").then(response => {this.contact = response.data})
  },
  methods: {
    sendForm: function () {
      axios.put("/contacts/api/callme/", this.contact)
      .then(response => {
        this.contact = response.data;
        this.step = 'complete';
      })
      .catch(error => {
        this.errors = error.response.data;
      });
    }
  }
}
</script>

<style lang="scss">
</style>
